import emptyPattern from "../../../../../assets/images/week-card-pattern.svg";

interface EmptyWeekViewProps {
    className: string;
}

export default function EmptyWeekView({ className }: EmptyWeekViewProps) {
    return (
        <div className={className}>
            <img
                className="w-full h-full object-cover"
                src={emptyPattern}
                alt="empty schedule"
            />
        </div>
    );
}
